import type { ReactNode } from "react";
import { Text } from "react-native";
import type { StyleProp, TextStyle } from "react-native";
import { colors, typography } from "../theme/tokens";

type Props = {
  children: ReactNode;
  style?: StyleProp<TextStyle>;
};

/** Label role for metric/value surfaces. */
export function MetricLabelText({ children, style }: Props) {
  return (
    <Text
      className="font-dm-sans"
      style={[
        {
          fontSize: 11,
          lineHeight: 14,
          color: colors.textLight,
          fontWeight: "800",
          textTransform: "uppercase",
        },
        style,
      ]}
    >
      {children}
    </Text>
  );
}

/**
 * Value role for metric/value surfaces. Display size is reserved for stat
 * blocks; compact is the default for cards and inline metric tiles.
 */
export function MetricValueText({
  children,
  style,
  size = "compact",
}: Props & { size?: "compact" | "display" }) {
  return (
    <Text
      className="font-dm-sans"
      style={[
        {
          fontFamily: typography.families.sansBold,
          fontSize: size === "display" ? 28 : 18,
          lineHeight: size === "display" ? 32 : 23,
          color: colors.text,
          fontWeight: size === "display" ? "700" : "800",
        },
        style,
      ]}
    >
      {children}
    </Text>
  );
}
